





































































import settings from '@/settings.coffee'

export default {
  "name": 'EstablignmentGatheringLine'
  "components": {}
  "data": ()->
      {settings}
  "computed":
      "title": ()->
          ret = ""
          if @review.title_fr and @review.title_fr != ""
              ret = @review.title_fr.substring(0,90)
          else if @review.title_native and @review.title_native != ""
              ret = @review.title_native.substring(0,90)
          else if @review.text_fr and @review.text_fr != ""
              ret = @review.text_fr.substring(0,90)
          else if @review.text_native and @review.text_native != ""
              ret = @review.text_native.substring(0,90)
          return ret
  "props":{
      "review":Object
  }
  "methods":
      is_done: (review)->
          return (
              review.current_state.class_name=='Classified' or
              review.current_state.class_name=='AnswerAccepted' or
              review.current_state.class_name=='AnswerPublished'
          )
      getBgColor: (review)->
          ret = "#FFFFFF"
          if @is_done(review)
              ret = "rgb(237, 242, 235)"
          return ret
      selectReview: (review)->
          window.dispatchEvent(new CustomEvent('click_gathering_review_detail', {detail:review}));            
  "mounted":()->
      return
}
